export default __webpack_public_path__ + "static/media/privete-notes-icon.80e9b474.svg";